<template>
  <div>
    <form-wizard color="#4a8cff" :title="null" :subtitle="null" layout="vertical" :finish-button-text="$t('Submit')" hide-buttons="true"
      ref="wizard" :next-button-text="$t('Next')" :back-button-text="$t('Previous')" class="wizard-vertical primary mb-3" @on-complete="formSubmitted">
      <tab-content :title="$t('Login Settings')" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">{{ $t('Custom Login End Point') }}</h5>
              <small class="text-muted">
                {{ $t('Please add your login url and other additional details. So users can sign in.') }} <br />
                {{ $t('To use custom login feature, your endpoint should prepare some dispatch endpoints to query between our system.') }}
              </small>
            </b-col>
            <b-col md="12">
              <login-end-configuration :title="$t('Authentication Url')" decription=""
                :subtitle="$t('Provide necessary permissions to access your LDAP system')"
               
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </login-end-configuration>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <!-- Branches datails tab -->
      <!-- <tab-content title="Branches" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Company Branches</h5>
              <small class="text-muted">
                Define branch retrieve method informations to fetch Branch Informations.
              </small>

            </b-col>
            <b-col cols="12">
              <branch-configuration title="" decription=""
                subtitle="Add your end point to receive country informations and map."
                description="The endpoint should support SSL  and response should return an object  including 'token','fullname','userid','photo','email','username' "
                sampleresponse=" { 'name':'Amazing Employee', photo:'https://mydomain.com/myphoto.jpg', 'email':'test@myemail.com','username':'testu',  'userid':225,  .... } "
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </branch-configuration>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content> -->
      <!-- account datails tab -->
      <!-- <tab-content title="Departments" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Company Branches</h5>
              <small class="text-muted">
                Define branch retrieve method informations to fetch Branch Informations.
              </small>
            </b-col>
            <b-col md="12">
              <department-configuration title="" decription=""
                subtitle="Add your end point to receive country informations and map."
                description="The endpoint should support SSL  and response should return an object  including 'token','fullname','userid','photo','email','username' "
                sampleresponse=" { 'name':'Amazing Employee', photo:'https://mydomain.com/myphoto.jpg', 'email':'test@myemail.com','username':'testu',  'userid':225,  .... } "
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </department-configuration>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content> -->

      <!-- account datails tab -->
      <!-- <tab-content title="Positions" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Company Branches</h5>
              <small class="text-muted">
                Define branch retrieve method informations to fetch Branch Informations.
              </small>

            </b-col>
            <b-col md="12">
              <position-configuration title="" decription=""
                subtitle="Add your end point to receive country informations and map."
                description="The endpoint should support SSL  and response should return an object  including 'token','fullname','userid','photo','email','username' "
                sampleresponse=" { 'name':'Amazing Employee', photo:'https://mydomain.com/myphoto.jpg', 'email':'test@myemail.com','username':'testu',  'userid':225,  .... } "
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </position-configuration>

            </b-col>

          </b-row>
        </validation-observer>
      </tab-content> -->

      <!-- account datails tab -->
      <tab-content :title="$t('Employees')" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">{{ $t('Company Employees') }}</h5>
              <small class="text-muted">
                {{ $t('Define employee retrieve method informations to fetch Employee Informations.') }}
              </small>

            </b-col>
            <b-col md="12">
              <employees-configuration :title="$t('')" decription=""
                :subtitle="$t('Add your end point to receive employee informations and map.')"
                :description="$t('The endpoint should support SSL and response should return an object including employee data fields')"
                :sampleresponse="$t('Sample Response: {name: Amazing Employee, photo: https://mydomain.com/myphoto.jpg, email: test@myemail.com, username: testu, userid: 225}')"
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </employees-configuration>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- account datails tab -->
      <!-- <tab-content title="Employee Detail" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Company Branches</h5>
              <small class="text-muted">
                Define branch retrieve method informations to fetch Branch Informations.
              </small>

            </b-col>
            <b-col md="12">
              <employee-detail-configuration title="" decription=""
                subtitle="Add your end point to receive country informations and map."
                description="The endpoint should support SSL  and response should return an object  including 'token','fullname','userid','photo','email','username' "
                sampleresponse=" { 'name':'Amazing Employee', photo:'https://mydomain.com/myphoto.jpg', 'email':'test@myemail.com','username':'testu',  'userid':225,  .... } "
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </employee-detail-configuration>

            </b-col>



          </b-row>
        </validation-observer>
      </tab-content> -->
      <!-- <tab-content title="New Employee" :before-change="canSwitch">
        <validation-observer ref="accountRules" tag="form">
          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Add new employee</h5>
              <small class="text-muted">

              </small>

            </b-col>
            <b-col md="12">
              <employee-add-configuration title="" decription="" subtitle="POST API to add new employee" description=" "
                sampleresponse=" { 'name':'Amazing Employee', photo:'https://mydomain.com/myphoto.jpg', 'email':'test@myemail.com','username':'testu',  'userid':225,  .... } "
                @datafetched="tokenReceived" :initial-login-info="clientData" @importdataclicked="importCountries">
              </employee-add-configuration>

            </b-col>



          </b-row>
        </validation-observer>
      </tab-content> -->

      <!-- <tab-content title="Migrate">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">Social Links</h5>
            <small class="text-muted">Enter Your Social Links</small>
          </b-col>
          <b-col md="6">
            <b-form-group label="Twitter" label-for="v-twitter">
              <b-form-input id="v-twitter" placeholder="https://twitter.com/abc" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Facebook" label-for="v-facebook">
              <b-form-input id="v-facebook" placeholder="https://facebook.com/abc" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Google+" label-for="v-google-plus">
              <b-form-input id="v-google-plus" placeholder="https://plus.google.com/abc" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="LinkedIn" label-for="v-linked-in">
              <b-form-input id="v-linked-in" placeholder="https://linkedin.com/abc" />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content> -->
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { BRow, BCol, BButton, BFormGroup, BFormInput, BAlert } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import clientSettingsStoreModule from './migrationStoreModule'
import { ref, onUnmounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomApiBuilder from './CustomApiBuilder.vue'
import BranchConfiguration from './BranchConfiguration.vue'
import DepartmentConfiguration from './DepartmentConfiguration.vue'
import PositionConfiguration from './PositionConfiguration.vue'
import EmployeesConfiguration from './EmployeeConfiguration.vue'
import EmployeeDetailConfiguration from './EmployeeDetailConfiguration.vue'

import EmployeeAddConfiguration from './EmployeeNewConfiguration.vue'
import LoginEndConfiguration from './LoginEndConfiguration.vue'
import axios from "@axios";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BButton,
    BCol,
    BFormGroup,
    BFormInput,
    BAlert,
    vSelect,
    CustomApiBuilder,
    LoginEndConfiguration,
    BranchConfiguration,
    DepartmentConfiguration,
    PositionConfiguration,
    EmployeesConfiguration,
    EmployeeDetailConfiguration,
    EmployeeAddConfiguration,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selectedLanguage: "nothing_selected",
      selectedContry: "Turkey",
      importedCountries: [],
      baseClientMigrateSettings: {
        loginInfo: {
          url: "",
          fetched: false,
          loginusername: "",
          loginpassword: "",
          requestMethod: "POST",
          loginToken: "",
          useTokeninHeader: true,
        },
        branchInfo: {
          url: "",
          fetched: false,
          loginusername: "",
          loginpassword: "",
          loginToken: "",
        },
        departmentInfo: {
          url: "",
          fetched: false,
          loginusername: "",
          loginpassword: "",
          loginToken: "",
        },
        positionInfo: {
          url: "",
          fetched: false,
          loginusername: "",
          loginpassword: "",
          loginToken: "",
        },

      },

      demoToken: null,
      selectedCountries: [],

    };
  },
  setup() {
    const clientData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-migration-settings'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, clientSettingsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-migration-settings/fetchMigrationSettings', { id: router.currentRoute.params.id })
      .then(response => {
        clientData.value = response.data;
      })
      .catch(error => {
        if (error.response.status === 404) {
          clientData.value = undefined
        }
      })

    return {
      clientData,
    }
  },
  mounted() {
    var wizard = this.$refs.wizard
    wizard.activateAll()
  },
  methods: {
    tokenReceived(payload) {
      //console.log("token updated");
      //console.log(payload);
      this.demoToken = payload;

    },
    canSwitch() {
      return new Promise((resolve, reject) => {
        resolve(true);
      });
    },

    loginConnected() {
      return new Promise((resolve, reject) => {

        if (this.demoToken != null || this.demoToken.length > 0) {
          resolve(true);
        } else {
          reject();
        }
      });
    },
    dataFetched(payload) {
      //console.log("dataFetched");
      //console.log(payload);
      //  this.importedCountries = payload;

    },
    importCountries(payload) {
      //console.log("importCountries");
      //console.log(payload);
      //    this.importedCountries = payload;

    },

    formSubmitted() {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: this.$t("Form Submitted"),
          icon: "EditIcon",
          variant: "success",
        },
      });
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/libs/vue-select.scss';

// Remove wizard button icons
.wizard-vertical .wizard-card-footer {
  .wizard-footer-left .wizard-btn::before {
    display: none !important;
  }
  .wizard-footer-right .wizard-btn::after {
    display: none !important;
  }
}
</style>